import React from 'react';
import { useAppSelector } from '../../store/hooks';

interface CLoaderProps {
  visible?: boolean;
  inline?: boolean;
}

const CLoader: React.FC<CLoaderProps> = ({ visible = true, inline = false }) => {
  const colors = useAppSelector((state) => state.theme.theme);

  if (!visible) {
    return null;
  }

  const spinner = (
    <div
      className="w-12 h-12 rounded-full border-4 animate-spin"
      style={{
        borderColor: colors.grayScale200,
        borderTopColor: colors.primary,
      }}
    />
  );

  if (inline) return spinner;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999]"
      style={{ backgroundColor: colors.modalBackground || 'rgba(0, 0, 0, 0.5)' }}
    >
      {spinner}
    </div>
  );
};

export default React.memo(CLoader);
